import React, { Component } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { CustomInput, Input, Modal } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import BranchAssignment from "../../components/Common/BranchAssignment";
import {
  createFood,
  getFoodCuisineList,
  removeFood,
  deleteFood,
  getFoodList,
  updateFood,
  getFoodById,
  getFoodAddOnList,
} from "../../Endpoint/Admin/index";

import { toast } from "react-toastify";
import { ConsolePage } from "../../components/Console/ConsoleLayout";
import {
  C, Btn, SearchPill, Pager,
} from "../../components/Console/ConsoleUI";
import { canWrite } from "../../services/PermissionService";

/**
 * Food menu — screen B1 of the console redesign.
 *
 * The menu reads as a menu now: a cuisine rail on the left, dish cards on the
 * right, each card carrying the one control a kitchen manager reaches for most
 * (is this dish on sale right now). Editing and deleting stay on the card so a
 * dish never has to be found twice.
 *
 * This is a re-skin only. Every request, every piece of state and every handler
 * below is the one the previous table-based screen used.
 */

/** Scoped CSS. Inline styles cannot reach the modal shell or a hover state. */
const CSS = `
.food-modal .modal-content{border:0;border-radius:22px;background:#fdf9f3;
  box-shadow:0 24px 60px rgba(0,0,0,.35);overflow:hidden}
.food-card{background:#fff;border:1px solid ${C.tint};border-radius:16px;overflow:hidden;
  display:flex;flex-direction:column;transition:box-shadow .15s,border-color .15s}
.food-card:hover{border-color:${C.sand};box-shadow:0 8px 22px rgba(61,40,23,.09)}
.food-cuisine{height:40px;display:flex;align-items:center;padding:0 12px;border-radius:12px;
  color:${C.slate};font-size:14px;cursor:pointer;border:0;background:transparent;width:100%;
  text-align:left;font-family:inherit}
.food-cuisine:hover{background:#f1e6d5}
.food-cuisine.is-active{background:${C.brown};color:#fff}
.food-iconbtn{width:30px;height:30px;border-radius:15px;border:0;background:rgba(255,255,255,.92);
  color:${C.brown};display:grid;place-items:center;cursor:pointer;padding:0;
  box-shadow:0 2px 6px rgba(61,40,23,.18)}
.food-iconbtn:hover{background:#fff}
.food-iconbtn.is-danger{color:${C.red}}
.food-newtile{border:1px dashed #dfcdb2;border-radius:16px;display:flex;flex-direction:column;
  align-items:center;justify-content:center;gap:9px;color:${C.taupeLight};min-height:210px;
  cursor:pointer;background:transparent;font-family:inherit;font-size:14px;width:100%}
.food-newtile:hover{border-color:${C.brown};color:${C.brown}}
.food-modal .form-control,.food-modal .custom-select{height:48px;padding:0 15px;background:#fff;
  border:1px solid #e6d8c4;border-radius:12px;font-size:15px;color:${C.ink};box-shadow:none}
.food-modal textarea.form-control{height:76px;padding:12px 15px;line-height:1.5;font-size:14px}
.food-modal .form-group{margin-bottom:0}
`;

const label = {
  fontSize: 12,
  letterSpacing: ".6px",
  color: C.taupe,
  marginBottom: 6,
  textTransform: "uppercase",
};

const money = (n) => `$${Number(n || 0).toFixed(2)}`;

/**
 * Dietary tags are typed as one comma-separated line. The server trims and
 * lowercases each tag; doing the same here (plus dropping empties and
 * duplicates) means what the preview shows is exactly what gets saved.
 */
const parseTags = (raw) => {
  const seen = {};
  return String(raw || "")
    .split(",")
    .map((t) => t.trim().toLowerCase())
    .filter((t) => {
      if (!t || seen[t]) return false;
      seen[t] = true;
      return true;
    });
};

/** A prep-time box as the trimmed string the form posts ("" = not set). */
const minutesText = (v) => (v === null || v === undefined ? "" : String(v).trim());

/**
 * Dish photo. Uploaded images are stored as plain filenames on older records,
 * so a broken src is expected rather than exceptional — it falls back to a
 * tinted plate icon instead of the browser's torn-image glyph.
 */
/**
 * Pill row across the food family, matching the one Rooms and Tables have.
 *
 * /FoodOrder was routed but reachable from nowhere - no rail entry and no link
 * - so 5,535 orders could only be opened by typing the URL.
 */
const NavPills = ({ items, active }) => (
  <div style={{ display: "flex", padding: 4, borderRadius: 21, background: "#efe2ce" }}>
    {items.map((i) => (
      <Link
        key={i.to}
        to={i.to}
        style={{
          padding: "8px 16px", borderRadius: 17, fontSize: 14, textDecoration: "none",
          whiteSpace: "nowrap",
          background: i.to === active ? C.brown : "transparent",
          color: i.to === active ? "#fff" : C.taupe,
        }}
      >
        {i.label}
      </Link>
    ))}
  </div>
);


class Thumb extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: !props.src };
  }

  render() {
    const { src, alt, height, width, muted } = this.props;
    const box = {
      width: width || "100%",
      height,
      objectFit: "cover",
      display: "block",
      filter: muted ? "grayscale(.6)" : "none",
    };
    if (this.state.failed) {
      return (
        <div
          style={{
            ...box,
            background: C.iconTint,
            display: "grid",
            placeItems: "center",
            color: C.sand,
          }}
        >
          <span className="ms" style={{ fontSize: 30 }}>restaurant</span>
        </div>
      );
    }
    return (
      <img
        src={src}
        alt={alt || ""}
        style={box}
        onError={() => this.setState({ failed: true })}
      />
    );
  }
}

/** The design's small pill switch, used for a dish's on-sale state. */
const Toggle = ({ on, onClick, title }) => (
  <span
    role="switch"
    aria-checked={!!on}
    aria-label={title}
    title={title}
    onClick={onClick}
    style={{
      width: 34,
      height: 20,
      borderRadius: 10,
      background: on ? C.green : "#e0d3bf",
      padding: 2,
      boxSizing: "border-box",
      display: "flex",
      justifyContent: on ? "flex-end" : "flex-start",
      cursor: onClick ? "pointer" : "default",
      flex: "0 0 auto",
    }}
  >
    <span style={{ width: 16, height: 16, borderRadius: 8, background: "#fff" }} />
  </span>
);

const Field = ({ title, children, style }) => (
  <div style={{ flex: 1, minWidth: 0, ...style }}>
    <div style={label}>{title}</div>
    {children}
  </div>
);

class FormMask extends Component {
  constructor(props) {
    super(props);
    this.state = {
      invalidFile: false,

      items: [],
      FoodCuisineData: [],
      FoodAddonData: [],
      isLoaded: false,
      // The grid is paged client-side. The fetch stays unpaginated on purpose:
      // the cuisine rail counts dishes per cuisine across the WHOLE menu, and
      // server paging would make those counts describe one page only.
      page: 1,
      limit: 24,
      updatemodal: false,
      modal: false,
      foodName: "",
      foodCuisine: "",
      description: "",
      availability: true,
      quantity: "",
      amount: "",
      discount: "",
      additionalCharges: "",
      foodImage: "",
      foodId: null,
      selectedFile: null,
      previewImage: [],
      availableAddOns: "",
      addons: "",
      branchIds: [],
      excludedBranchIds: [],
      branchOverrides: [],
      // Menu details. isVeg is three-way on the server ("" = not specified,
      // stored as null), so it is a select rather than a toggle.
      pairedFoodIds: [],
      isVeg: "",
      isBestseller: false,
      isRecommended: false,
      dietaryTags: "",
      prepTimeMin: "",
      prepTimeMax: "",
      success: {},
      // View-only filters. They never touch what is fetched.
      search: "",
      activeCuisine: "",
      breadcrumbItems: [
        { title: "", link: "#" },
        { title: " ", link: "#" },
      ],
      customchk: true,
      toggleSwitch: true,
      tableData: {
        columns: [
          {
            label: "Food Name",
            field: "foodName",
            sort: "asc",
            width: 60,
          },

          ...(canWrite() ? [{
            label: "Update",
            field: "update",
            sort: "asc",
            width: 100,
          }] : []),

          ...(canWrite() ? [{
            label: "Status",
            field: "remove",
            sort: "asc",
            width: 100,
          }] : []),
        ],
        rows: [],
      },
    };

    this.reader = new FileReader();
    this.handleChange = this.handleChange.bind(this);
    this.onFileChange = this.onFileChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggle = this.toggle.bind(this);
    this.ShortlistedUser = this.ShortlistedUser.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.onChange = this.onChange.bind(this);
  }
  toggle() {
    this.setState({
      modal: !this.state.modal,
      foodName: "",
      foodCuisine: "",
      description: "",
      availability: "",
      quantity: "",
      amount: "",
      discount: "",
      additionalCharges: "",
      foodImage: "",
      selectedFile: "",
      previewImage: "",
      availableAddOns: "",
      invalidImage: null,
      foodId: "",
      branchIds: [],
      excludedBranchIds: [],
      branchOverrides: [],
      pairedFoodIds: [],
      isVeg: "",
      isBestseller: false,
      isRecommended: false,
      dietaryTags: "",
      prepTimeMin: "",
      prepTimeMax: "",
    });
  }
  updatetoggle() {
    this.setState({
      updatemodal: !this.state.updatemodal,
    });
  }

  onChange(selectedOptions) {
    this.setState({
      availableAddOns: [...selectedOptions],
    });
  }

  ShortlistedUser() {
    this.setState({
      availability: !this.state.availability,
    });
  }

  handleCloseModal() {
    this.setState({
      updatemodal: false,
      modal: false,
    });
  }

  handleChange = (e) => {
    this.setState(
      {
        [e.target.id]: e.target.value,
      },
      () => {}
    );
  };

  onFileChange(event) {
    const imageFile = event.target.files;
    for (let i = 0; i < imageFile.length; i++) {
      if (!imageFile[i].name.match(/\.(jpg|jpeg|png)$/)) {
        this.setState({
          invalidImage: "Please select valid image.",
          previewImage: [...event.target.files].map(URL.createObjectURL),
        });
        return false;
      } else {
        this.setState({
          selectedFile: event.target.files,
          previewImage: [...event.target.files].map(URL.createObjectURL),
          invalidImage: null,
        });
      }
    }
  }

  FoodCuisineListList() {
    getFoodCuisineList()
      .then((result) => {
        this.setState({
          FoodCuisineData: result.data,
        });
      })
      .catch((error) => {
        console.log("error ---> ", error);
      });
  }
  FoodAddonList() {
    getFoodAddOnList()
      .then((result) => {
        this.setState({
          FoodAddonData: result.data,
        });
        const dropDownValue = this.state.FoodAddonData.map((response) => ({
          value: response._id,
          label: response.foodAddOnName,
        }));
        this.setState({
          dropDownOpt: dropDownValue,
        });
      })
      .catch((error) => {});
  }

  handleSubmit(e) {
    e.preventDefault();

    const prepMin = minutesText(this.state.prepTimeMin);
    const prepMax = minutesText(this.state.prepTimeMax);
    if (prepMin !== "" && !(Number.isFinite(Number(prepMin)) && Number(prepMin) >= 0)) {
      toast.error("Minimum prep time must be 0 minutes or more");
      return;
    }
    if (prepMax !== "" && !(Number.isFinite(Number(prepMax)) && Number(prepMax) >= 0)) {
      toast.error("Maximum prep time must be 0 minutes or more");
      return;
    }
    if (prepMin !== "" && prepMax !== "" && Number(prepMin) > Number(prepMax)) {
      toast.error("Minimum prep time cannot be more than the maximum");
      return;
    }

    let addon = [];

    this.state.availableAddOns &&
      this.state.availableAddOns.map((each) => {
        addon.push(each.value);
        return each;
      });

    const formData = new FormData();

    formData.append("foodName", this.state.foodName);
    formData.append("foodCuisine", this.state.foodCuisine);
    formData.append("description", this.state.description);
    formData.append("availability", this.state.availability);
    formData.append("quantity", this.state.quantity);
    formData.append("amount", this.state.amount);
    formData.append("discount", this.state.discount);
    //formData.append("additionalCharges", this.state.additionalCharges);
    formData.append("foodId", this.state.foodId);
    formData.append("availableAddOns", addon);
    formData.append("branchIds", JSON.stringify(this.state.branchIds || []));
    formData.append(
      "excludedBranchIds",
      JSON.stringify(this.state.excludedBranchIds || [])
    );
    formData.append(
      "branchPriceOverrides",
      JSON.stringify(this.state.branchOverrides || [])
    );
    // Menu details. Every field is always sent: on the server "" (or "[]")
    // clears a value, so leaving one out would keep a value the admin emptied.
    formData.append(
      "pairedFoodIds",
      JSON.stringify(
        (this.state.pairedFoodIds || []).filter(
          (id) => String(id) !== String(this.state.foodId || "")
        )
      )
    );
    formData.append("isVeg", this.state.isVeg || "");
    formData.append("isBestseller", this.state.isBestseller ? "true" : "false");
    formData.append("isRecommended", this.state.isRecommended ? "true" : "false");
    formData.append("dietaryTags", JSON.stringify(parseTags(this.state.dietaryTags)));
    formData.append("prepTimeMin", prepMin);
    formData.append("prepTimeMax", prepMax);
    for (var x = 0; x < this.state.selectedFile.length; x++) {
      formData.append("foodImage", this.state.selectedFile[x]);
    }

    if (this.state.foodId == "" || this.state.foodId == null) {
      createFood(formData)
        .then((response) => {
          if (response.status !== 200) {
            toast.error(response.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            this.setState({
              handleResponse: {
                isSuccess: response.status === 200,
                message: "success",
                foodName: "",
                foodCuisine: "",
                description: "",
                availability: false,
                quantity: "",
                amount: "",
                discount: "",
                additionalCharges: "",
                foodImage: "",
                selectedFile: "",
                previewImage: "",
                reviews: "",
                foodId: "",
                availableAddOns: "",
              },
            });
            this.getALlluser();

            this.handleCloseModal();

            toast.success("Food added successfully");
          }
        })
        .catch((error) => {
          toast.error("error");
        });
    } else {
      updateFood(formData)
        .then((updateResults) => {
          if (updateResults.status !== 200) {
            toast.error(updateResults.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            this.setState({
              handleResponse: {
                isSuccess: updateResults.status === 200,
                message: "success",
                foodId: "",
              },
            });
            this.getALlluser();

            this.handleCloseModal();

            toast.success("Food updated successfully.");
          }
        })
        .catch((error) => {
          toast.error("error");
        });
    }
  }

  removeFood(id, isActive) {
    const data = {
      foodId: id,
      isActive: isActive,
    };

    removeFood(data)
      .then((results) => {
        if (results.status !== 200) {
          toast.error(results.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else {
          toast.success("Food status changed successfully");
        }
        this.getALlluser();
      })
      .catch((error) => {
        toast.error("error");
      });
  }

  deleteFoodItem(id, foodName) {
    if (window.confirm(`Are you sure you want to permanently delete "${foodName}"? This action cannot be undone.`)) {
      deleteFood(id)
        .then((results) => {
          if (results && results.status === 200) {
            toast.success("Food item deleted successfully");
            this.getALlluser();
          } else {
            toast.error(results?.message || "Failed to delete food item", {
              position: "top-right",
              autoClose: 5000,
            });
          }
        })
        .catch((error) => {
          toast.error("Error deleting food item");
        });
    }
  }

  getALlluser() {
    getFoodList().then((result) => {
      this.setState({
        isLoaded: true,
        items: result.data,
        tableData: {
          ...this.state.tableData,
          rows: result.data,
          list: result.data.map((x) => {
            x.isActive = x.isActive === true ? false : true;
            x.update = canWrite() ? (
              <button
                className="btn btn-primary btn-sm"
                onClick={() => this.editfood(x._id.toString(), x)}
              >
                Update
              </button>
            ) : null;
            x.remove = canWrite() ? (
              <div className="d-flex gap-1">
                <button
                  className={`btn btn-sm ${x.isActive === true ? "btn-warning" : "btn-success"}`}
                  onClick={() => this.removeFood(x._id.toString(), x.isActive)}
                  title={x.isActive === true ? "Deactivate" : "Activate"}
                >
                  {x.isActive === true ? "Deactive" : "Active"}
                </button>
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => this.deleteFoodItem(x._id.toString(), x.foodName)}
                  title="Permanently delete"
                >
                  Delete
                </button>
              </div>
            ) : null;

            return x;
          }),
        },
      });
    });
  }
  editfood(id) {
    getFoodById(id)
      .then((results) => {
        let copyfoodrpreview = [];
        let addonscopy = [];
        for (let i = 0; i < results.data.foodImages.length; i++) {
          copyfoodrpreview.push(results.data.foodImages[i].image);
        }

        addonscopy =
          results.data.availableAddOns &&
          results.data.availableAddOns.map((response) => ({
            value: response._id,
            label: response.foodAddOnName,
          }));

        this.setState({
          foodName: results.data.foodName,
          previewImage: copyfoodrpreview,

          foodId: results.data._id,
          foodCuisine: results.data.foodCuisine._id,
          description: results.data.description,
          availability: results.data.availability,
          quantity: results.data.quantity,
          amount: results.data.amount,
          discount: results.data.discount,
          availableAddOns: addonscopy,
          branchIds: (results.data.branchIds || []).map((b) =>
            b && b._id ? b._id : String(b)
          ),
          excludedBranchIds: (results.data.excludedBranchIds || []).map((b) =>
            b && b._id ? b._id : String(b)
          ),
          branchOverrides: results.data.branchPriceOverrides || [],
          pairedFoodIds: (results.data.pairedFoodIds || [])
            .map((p) => (p && p._id ? String(p._id) : String(p)))
            .filter((p) => p !== String(results.data._id)),
          isVeg:
            results.data.isVeg === true
              ? "true"
              : results.data.isVeg === false
              ? "false"
              : "",
          isBestseller: !!results.data.isBestseller,
          isRecommended: !!results.data.isRecommended,
          dietaryTags: (results.data.dietaryTags || []).join(", "),
          prepTimeMin: minutesText(results.data.prepTimeMin),
          prepTimeMax: minutesText(results.data.prepTimeMax),
        });
      })
      .catch((error) => {
        console.log(error);
        toast.error("error");
      });
    this.toggle();
  }
  componentDidMount() {
    this.getALlluser();
    this.FoodCuisineListList();
    this.FoodAddonList();
  }

  // --- presentation helpers -------------------------------------------------

  /**
   * The list loader flips `isActive` in place so the row's button can post the
   * value the toggle should switch *to*. A dish is therefore on sale when the
   * flipped flag reads false — kept in one place so the cards and the button
   * can never disagree about it.
   */
  isOnSale = (food) => food.isActive === false;

  cuisineIdOf = (food) => {
    const c = food.foodCuisine;
    if (!c) return "";
    return String(c._id || c);
  };

  cuisineNameOf = (food) => {
    const id = this.cuisineIdOf(food);
    const hit = (this.state.FoodCuisineData || []).find((c) => String(c._id) === id);
    return hit ? hit.cuisineName : "";
  };

  visibleItems() {
    const { items, search, activeCuisine } = this.state;
    const q = search.trim().toLowerCase();
    return (items || []).filter((f) => {
      if (activeCuisine && this.cuisineIdOf(f) !== activeCuisine) return false;
      if (!q) return true;
      return (
        (f.foodName || "").toLowerCase().includes(q) ||
        (f.description || "").toLowerCase().includes(q)
      );
    });
  }

  renderCuisineRail() {
    const { items, FoodCuisineData, activeCuisine } = this.state;
    const counts = {};
    (items || []).forEach((f) => {
      const id = this.cuisineIdOf(f);
      counts[id] = (counts[id] || 0) + 1;
    });
    const onSale = (items || []).filter(this.isOnSale).length;

    const row = (id, name, count) => (
      <button
        key={id || "all"}
        type="button"
        className={`food-cuisine${activeCuisine === id ? " is-active" : ""}`}
        onClick={() => this.setState({ activeCuisine: id, page: 1 })}
      >
        {name}
        <span
          style={{
            marginLeft: "auto",
            fontSize: 13,
            color: activeCuisine === id ? "rgba(255,255,255,.7)" : C.taupeLight,
          }}
        >
          {count}
        </span>
      </button>
    );

    return (
      <div
        style={{
          flex: "0 0 210px",
          borderRight: `1px solid ${C.border}`,
          paddingRight: 18,
          display: "flex",
          flexDirection: "column",
          gap: 4,
        }}
      >
        <div
          style={{
            fontSize: 12,
            fontWeight: 700,
            letterSpacing: 1,
            color: C.taupeLight,
            padding: "0 12px 8px",
          }}
        >
          CUISINES
        </div>
        {row("", "All dishes", (items || []).length)}
        {(FoodCuisineData || []).map((c) =>
          row(String(c._id), c.cuisineName, counts[String(c._id)] || 0)
        )}

        <div
          style={{
            marginTop: 18,
            padding: 14,
            borderRadius: 14,
            background: "#fff",
            border: `1px solid ${C.tint}`,
          }}
        >
          <div style={{ fontSize: 13, color: C.taupe }}>On the menu now</div>
          <div style={{ marginTop: 6, fontSize: 20, color: C.ink }}>
            {onSale}
            <span style={{ fontSize: 14, color: C.taupeLight }}>
              {" "}
              of {(items || []).length}
            </span>
          </div>
          <div style={{ marginTop: 10, fontSize: 13, color: C.taupe }}>
            The rest are hidden from the guest app.
          </div>
        </div>
      </div>
    );
  }

  renderCard(food) {
    const on = this.isOnSale(food);
    const img = (food.foodImages || [])[0];
    const price = food.finalAmount != null ? food.finalAmount : food.amount;
    const cut = Number(food.discount || 0) > 0;
    const write = canWrite();

    return (
      <div key={food._id} className="food-card" style={{ opacity: on ? 1 : 0.72 }}>
        <div style={{ position: "relative" }}>
          <Thumb src={img && img.image} alt={food.foodName} height={118} muted={!on} />
          {write && (
            <div style={{ position: "absolute", top: 10, right: 10, display: "flex", gap: 6 }}>
              <button
                type="button"
                className="food-iconbtn"
                title={`Edit ${food.foodName}`}
                onClick={() => this.editfood(food._id.toString(), food)}
              >
                <span className="ms" style={{ fontSize: 17 }}>edit</span>
              </button>
              <button
                type="button"
                className="food-iconbtn is-danger"
                title={`Delete ${food.foodName}`}
                onClick={() => this.deleteFoodItem(food._id.toString(), food.foodName)}
              >
                <span className="ms" style={{ fontSize: 17 }}>delete</span>
              </button>
            </div>
          )}
        </div>

        <div style={{ padding: 14, display: "flex", flexDirection: "column", flex: 1 }}>
          <div style={{ fontSize: 15, color: C.ink }}>{food.foodName}</div>
          <div
            style={{
              marginTop: 4,
              fontSize: 12,
              color: C.taupeLight,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
            title={food.description || ""}
          >
            {food.description || this.cuisineNameOf(food) || "No description"}
          </div>

          <div
            style={{
              marginTop: 10,
              paddingTop: 10,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 10,
            }}
          >
            <div style={{ display: "flex", alignItems: "baseline", gap: 7 }}>
              <span style={{ fontSize: 16, fontWeight: 500, color: C.ink }}>{money(price)}</span>
              {cut && (
                <span
                  style={{ fontSize: 12, color: C.taupeLight, textDecoration: "line-through" }}
                >
                  {money(food.amount)}
                </span>
              )}
            </div>
            {write ? (
              <Toggle
                on={on}
                title={on ? `Take ${food.foodName} off the menu` : `Put ${food.foodName} on the menu`}
                onClick={() => this.removeFood(food._id.toString(), food.isActive)}
              />
            ) : (
              <span style={{ fontSize: 12, color: on ? "#2f7d33" : C.taupeLight }}>
                {on ? "On menu" : "Hidden"}
              </span>
            )}
          </div>
        </div>
      </div>
    );
  }

  /**
   * "Goes well with" choices: every other dish on the menu. A saved pairing
   * that is not in the loaded list (another branch's dish, say) keeps a
   * placeholder label so saving the form does not silently drop it.
   */
  pairingOptions() {
    const self = String(this.state.foodId || "");
    return (this.state.items || [])
      .filter((f) => String(f._id) !== self)
      .map((f) => ({ value: String(f._id), label: f.foodName }));
  }

  pairingValue(options) {
    return (this.state.pairedFoodIds || []).map(
      (id) =>
        options.find((o) => o.value === id) || { value: id, label: "Dish not in this list" }
    );
  }

  /** One tappable row with the pill switch, same as the availability row. */
  renderFlag(key, text) {
    return (
      <div
        onClick={() => this.setState({ [key]: !this.state[key] })}
        style={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          gap: 12,
          padding: "14px 16px",
          borderRadius: 14,
          background: C.iconTint,
          cursor: "pointer",
        }}
      >
        <div style={{ flex: 1, fontSize: 14, color: C.slate }}>{text}</div>
        <Toggle on={!!this.state[key]} title={text} />
      </div>
    );
  }

  renderModal() {
    const { handleResponse, invalidImage, previewImage, foodId } = this.state;
    const editing = !!foodId;
    const pairing = this.pairingOptions();
    const tags = parseTags(this.state.dietaryTags);

    return (
      <Modal
        isOpen={this.state.modal}
        toggle={this.toggle}
        className={`con-modal food-modal ${this.props.className || ""}`}
        size="lg"
      >
        <div style={{ padding: 30 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 22, fontWeight: 500, color: C.ink }}>
                {editing ? "Edit menu item" : "Add menu item"}
              </div>
              <div style={{ marginTop: 4, fontSize: 14, color: C.taupe }}>
                {editing
                  ? "Changes reach the guest app as soon as you save"
                  : "New dishes appear on the guest app once available"}
              </div>
            </div>
            <button
              type="button"
              onClick={this.toggle}
              aria-label="Close"
              style={{
                border: 0,
                background: "transparent",
                color: C.taupeLight,
                cursor: "pointer",
                padding: 4,
                lineHeight: 1,
              }}
            >
              <span className="ms" style={{ fontSize: 22 }}>close</span>
            </button>
          </div>

          <AvForm onValidSubmit={this.handleSubmit}>
            <div style={{ marginTop: 22, display: "flex", gap: 16 }}>
              {/* The real file input stays exactly as it was — hidden, and
                  driven by the label below, so validation and the change
                  handler are untouched. */}
              <div style={{ display: "none" }}>
                <AvField
                  tag={CustomInput}
                  name="file"
                  id="file"
                  type="file"
                  accept="image/*"
                  onChange={this.onFileChange}
                  multiple
                />
              </div>
              <label
                htmlFor="file"
                style={{
                  width: 132,
                  height: 132,
                  borderRadius: 16,
                  border: "1.5px dashed #d9c3a5",
                  background: "#fff",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 8,
                  color: C.taupeLight,
                  cursor: "pointer",
                  margin: 0,
                  flex: "0 0 132px",
                  overflow: "hidden",
                }}
              >
                {(previewImage || []).length > 0 ? (
                  <Thumb src={(previewImage || [])[0]} alt="Selected dish" height={132} width={132} />
                ) : (
                  <React.Fragment>
                    <span className="ms" style={{ fontSize: 26 }}>add_photo_alternate</span>
                    <span style={{ fontSize: 12 }}>Upload photo</span>
                  </React.Fragment>
                )}
              </label>

              <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 14 }}>
                <Field title="Item name">
                  <AvField
                    type="text"
                    value={this.state.foodName}
                    onChange={this.handleChange}
                    id="foodName"
                    name="foodName"
                    required
                                  errorMessage="Food name is required"
                                />
                </Field>
                <div style={{ display: "flex", gap: 12 }}>
                  <Field title="Price (USD)">
                    <AvField
                      type="number"
                      min={1}
                      value={this.state.amount}
                      onChange={this.handleChange}
                      id="amount"
                      name="amount"
                      required
                                  errorMessage="Amount is required"
                                />
                  </Field>
                  <Field title="Discount (USD)">
                    <AvField
                      type="number"
                      min={0}
                      value={this.state.discount}
                      onChange={this.handleChange}
                      id="discount"
                      name="discount"
                    />
                  </Field>
                </div>
              </div>
            </div>

            <div style={{ marginTop: 16, display: "flex", gap: 12 }}>
              <Field title="Cuisine">
                <Input
                  type="select"
                  name="foodCuisine"
                  id="foodCuisine"
                  value={this.state.foodCuisine}
                  onChange={this.handleChange}
                  required
                >
                  <option>Select FoodCuisine</option>
                  {this.state.FoodCuisineData.map((e, key) => {
                    return (
                      <option key={key} value={e._id}>
                        {e.cuisineName}
                      </option>
                    );
                  })}
                </Input>
              </Field>
              <Field title="Quantity">
                <AvField
                  type="text"
                  value={this.state.quantity}
                  onChange={this.handleChange}
                  id="quantity"
                  name="quantity"
                  required
                                  errorMessage="Quantity is required"
                                />
              </Field>
            </div>

            <div style={{ marginTop: 16 }}>
              <Field title="Description">
                <AvField
                  type="textarea"
                  value={this.state.description}
                  onChange={this.handleChange}
                  id="description"
                  name="description"
                />
              </Field>
            </div>

            <div style={{ marginTop: 16 }}>
              <Field title="Available add-ons">
                <Select
                  className="dropdown"
                  placeholder="Select Option"
                  options={this.state.dropDownOpt}
                  value={this.state.availableAddOns}
                  onChange={this.onChange}
                  isMulti
                  isClearable
                />
              </Field>
            </div>

            <div style={{ marginTop: 16, display: "flex", gap: 12 }}>
              <Field title="Veg / non-veg">
                <Input
                  type="select"
                  name="isVeg"
                  id="isVeg"
                  value={this.state.isVeg}
                  onChange={this.handleChange}
                >
                  <option value="">Not specified</option>
                  <option value="true">Veg</option>
                  <option value="false">Non-veg</option>
                </Input>
              </Field>
              <Field title="Prep time min (minutes)">
                <AvField
                  type="number"
                  min={0}
                  value={this.state.prepTimeMin}
                  onChange={this.handleChange}
                  id="prepTimeMin"
                  name="prepTimeMin"
                />
              </Field>
              <Field title="Prep time max (minutes)">
                <AvField
                  type="number"
                  min={0}
                  value={this.state.prepTimeMax}
                  onChange={this.handleChange}
                  id="prepTimeMax"
                  name="prepTimeMax"
                />
              </Field>
            </div>

            <div style={{ marginTop: 16 }}>
              <Field title="Dietary tags (comma separated)">
                <AvField
                  type="text"
                  value={this.state.dietaryTags}
                  onChange={this.handleChange}
                  id="dietaryTags"
                  name="dietaryTags"
                  placeholder="e.g. vegan, spicy, gluten-free"
                />
              </Field>
              {tags.length > 0 && (
                <div style={{ marginTop: 8, display: "flex", gap: 6, flexWrap: "wrap" }}>
                  {tags.map((t) => (
                    <span
                      key={t}
                      style={{
                        padding: "3px 10px",
                        borderRadius: 12,
                        background: C.iconTint,
                        color: C.slate,
                        fontSize: 12,
                      }}
                    >
                      {t}
                    </span>
                  ))}
                </div>
              )}
            </div>

            <div style={{ marginTop: 16 }}>
              <Field title="Goes well with">
                <Select
                  className="dropdown"
                  placeholder="Select dishes"
                  options={pairing}
                  value={this.pairingValue(pairing)}
                  onChange={(opts) =>
                    this.setState({
                      pairedFoodIds: (opts || []).map((o) => o.value),
                    })
                  }
                  isMulti
                  isClearable
                />
              </Field>
            </div>

            {(previewImage || []).length > 1 && (
              <div style={{ marginTop: 14, display: "flex", gap: 8, flexWrap: "wrap" }}>
                {(previewImage || []).slice(1).map((url, i) => (
                  <div
                    key={i}
                    style={{ width: 56, height: 56, borderRadius: 12, overflow: "hidden" }}
                  >
                    <Thumb src={url} alt="" height={56} width={56} />
                  </div>
                ))}
              </div>
            )}

            <div
              onClick={this.ShortlistedUser}
              style={{
                marginTop: 18,
                display: "flex",
                alignItems: "center",
                gap: 12,
                padding: "14px 16px",
                borderRadius: 14,
                background: C.iconTint,
                cursor: "pointer",
              }}
            >
              <div style={{ flex: 1, fontSize: 14, color: C.slate }}>
                Available to order in the guest app
              </div>
              <Toggle on={!!this.state.availability} title="Availability" />
            </div>

            <div style={{ marginTop: 12, display: "flex", gap: 12 }}>
              {this.renderFlag("isBestseller", "Bestseller")}
              {this.renderFlag("isRecommended", "Recommended")}
            </div>

            <div style={{ marginTop: 18 }}>
              <BranchAssignment
                branchIds={this.state.branchIds}
                excludedBranchIds={this.state.excludedBranchIds}
                overrides={this.state.branchOverrides}
                priceFields={[
                  { key: "amount", label: "Amount" },
                  { key: "discount", label: "Discount" },
                  { key: "finalAmount", label: "Final" },
                ]}
                onChange={({ branchIds, excludedBranchIds, overrides }) =>
                  this.setState({
                    branchIds,
                    excludedBranchIds,
                    branchOverrides: overrides,
                  })
                }
              />
            </div>

            {invalidImage && (
              <p style={{ marginTop: 12, marginBottom: 0, color: C.red, fontSize: 13 }}>
                {invalidImage}
              </p>
            )}
            {handleResponse && (
              <p
                style={{
                  marginTop: 12,
                  marginBottom: 0,
                  fontSize: 13,
                  color: handleResponse.isSuccess ? C.green : C.red,
                }}
              >
                {handleResponse.message}
              </p>
            )}

            <div style={{ marginTop: 24, display: "flex", gap: 12 }}>
              <button
                type="button"
                onClick={this.toggle}
                style={{
                  flex: 1,
                  height: 52,
                  border: "1px solid #e6d8c4",
                  borderRadius: 26,
                  background: "#fff",
                  color: C.slate,
                  fontFamily: "inherit",
                  fontSize: 15,
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
              <button
                style={{
                  flex: 1,
                  height: 52,
                  border: 0,
                  borderRadius: 26,
                  background: C.brown,
                  color: "#fff",
                  fontFamily: "inherit",
                  fontSize: 15,
                  cursor: "pointer",
                }}
              >
                {editing ? "Save changes" : "Add item"}
              </button>
            </div>
          </AvForm>
        </div>
      </Modal>
    );
  }

  render() {
    const { items, isLoaded, search, activeCuisine, FoodCuisineData } = this.state;
    const visible = this.visibleItems();
    const { page, limit } = this.state;
    const totalPages = Math.max(1, Math.ceil(visible.length / limit));
    const current = Math.min(page, totalPages);
    const pageItems = visible.slice((current - 1) * limit, current * limit);
    const cuisine = (FoodCuisineData || []).find((c) => String(c._id) === activeCuisine);
    const heading = cuisine ? cuisine.cuisineName : "All dishes";
    const write = canWrite();

    return (
      <ConsolePage
        title="Menu & items"
        subtitle={
          isLoaded
            ? `${(items || []).length} dishes · ${(FoodCuisineData || []).length} cuisines`
            : "Loading the menu…"
        }
        actions={
          <React.Fragment>
            <NavPills
              active="/Food"
              items={[
                { to: "/Food", label: "Menu & items" },
                { to: "/FoodOrder", label: "Orders" },
                { to: "/Foodcuisine", label: "Cuisines" },
              ]}
            />
            <SearchPill
              value={search}
              onChange={(v) => this.setState({ search: v, page: 1 })}
              placeholder="Search dishes"
              width={220}
            />
            <Btn
              kind="quiet"
              icon="tune"
              onClick={() => this.props.history.push("/FoodAddOn")}
            >
              Add-ons
            </Btn>
            {write && (
              <Btn icon="add" onClick={this.toggle}>
                New item
              </Btn>
            )}
          </React.Fragment>
        }
      >
        <style dangerouslySetInnerHTML={{ __html: CSS }} />

        <div style={{ display: "flex", gap: 22, alignItems: "flex-start" }}>
          {this.renderCuisineRail()}

          <div style={{ flex: 1, minWidth: 0 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 16,
              }}
            >
              <div style={{ fontSize: 17, fontWeight: 500, color: C.ink }}>
                {heading} · {visible.length} item{visible.length === 1 ? "" : "s"}
              </div>
              {search.trim() !== "" && (
                <button
                  type="button"
                  onClick={() => this.setState({ search: "" })}
                  style={{
                    border: 0,
                    background: "transparent",
                    color: C.taupe,
                    fontSize: 14,
                    fontFamily: "inherit",
                    cursor: "pointer",
                  }}
                >
                  Clear search
                </button>
              )}
            </div>

            {!isLoaded ? (
              <div style={{ padding: "60px 0", textAlign: "center", color: C.taupeLight }}>
                Loading dishes…
              </div>
            ) : (
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(195px, 1fr))",
                  gap: 16,
                }}
              >
                {pageItems.map((f) => this.renderCard(f))}

                {write && (
                  <button type="button" className="food-newtile" onClick={this.toggle}>
                    <span className="ms" style={{ fontSize: 26 }}>add_photo_alternate</span>
                    <span>
                      Add {cuisine ? cuisine.cuisineName.toLowerCase() : "menu"} item
                    </span>
                  </button>
                )}

                {visible.length === 0 && !write && (
                  <div style={{ padding: "60px 0", color: C.taupeLight }}>
                    No dishes match this filter.
                  </div>
                )}
              </div>
            )}

            {visible.length > limit && (
              <Pager
                page={current}
                totalPages={totalPages}
                total={visible.length}
                limit={limit}
                onPage={(n) => this.setState({ page: n })}
                onLimit={(n) => this.setState({ limit: n, page: 1 })}
                noun="dishes"
              />
            )}
          </div>
        </div>

        {this.renderModal()}
      </ConsolePage>
    );
  }
}

export default FormMask;
